import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import { Row, Col, Modal } from 'react-bootstrap';
import _orderBy from 'lodash/orderBy';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';
import Heading from '../components/Heading';
import SearchBar from '../components/SearchBar';
import * as API from '../services/api';
import loader from '../assets/loader.svg';
import Select from '../components/Select';
import actions from '../redux/actions';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      planModalOpen: false,
      subscriptionPlan: 'free',
      isPremiumExpired: false,
      searchText: '',
      coregs: [],
      initCoregs: [],
      showDetailModal: false,
      selectedCoreg: null,
      loading: false,
    };
  }

  componentWillMount() {
    const signupPlan = cookie.load('signupPlan');
    // console.log('SIGNUP_PLAN_COOKIE', signupPlan)
    if (signupPlan && signupPlan !== 'free') {
      // show the subscriptin plan selected from pricing page before registration
      if (signupPlan === 'creg') {
        cookie.remove('signupPlan', {
          path: '/',
        });
        this.props.router.push('/copyright-reg');
      }
    } else {
      cookie.remove('signupPlan', {
        path: '/',
      });
    }

    if (this.props.profile.id) {
      this.setState({ loading: true });
      this.loadCoregs(this.props.profile.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { profile } = nextProps;

    if (profile) {
      if (
        (profile.subscription_plan === 'premium' &&
          profile.trial_expired === true) ||
        (profile.subscription_plan === 'free' &&
          (profile.referrer.includes('cdbaby') ||
            profile.referrer.includes('soundrop')))
      ) {
        // show payment modal for over trialed user
        this.setState({
          planModalOpen: true,
          subscriptionPlan: profile.subscription_plan,
          isPremiumExpired: true,
        });
      }

      if (this.props.profile.id !== profile.id) {
        this.loadCoregs(profile.id);
      }
    }
  }

  loadCoregs(userId) {
    API.getCoregs(userId).then(async (res) => {
      let publicInfoUrls = [];
      const coregs = await Promise.all(_map(
        _filter(
          _map(
            _orderBy(res, [(creg) => creg.date_created], ['desc']), (creg) => {
              const cregData = JSON.parse(creg.data);

              if (publicInfoUrls.includes(cregData.publishInfo.url)) return null;

              publicInfoUrls.push(cregData.publishInfo.url);

              return {
                ...creg,
                data: cregData,
              };
            }
          ), (res) => res && res.data.publishInfo && res.data.publishInfo.url
        ), async (coreg) => {
          const uniqueDateTime = [];
          let snapshots = await API.getCoregSnapshots(coreg.id);

          if (snapshots.length) {
            snapshots = _forEach(
              _orderBy(snapshots, [(creg) => creg.date_taken], ['desc']), (snapshot) => {
                const formatDateTaken = moment(snapshot.date_taken).add(1, 'day').format('MMM YYYY');

                if (!uniqueDateTime.includes(formatDateTaken)) {
                  uniqueDateTime.push(formatDateTaken);
                }
              }
            );
          }

          return {
            ...coreg,
            uniqueDateTime,
          }
        }));

      // console.info('Coregs:', coregs);

      this.setState({
        coregs,
        initCoregs: coregs,
        loading: false,
      });
    });
  }

  handleSearch = (e) => {
    e.preventDefault();
    const searchText = e.target.value;
    this.setState({ searchText }, () => {
      this.searchCoreg(searchText);
    });
  };

  clearSearch = (e) => {
    e.preventDefault();
    this.setState({ searchText: '', coregs: this.state.initCoregs });
  };

  searchCoreg = (searchText) => {
    const { initCoregs } = this.state;
    let searchedCoregs = _filter(
      initCoregs,
      (coreg) => coreg.data.titleTypes.titleOfPublication.toLowerCase().includes(searchText.toLowerCase())
    );

    searchedCoregs = _orderBy(
      searchedCoregs,
      [(creg) => creg.date_created],
      ['desc']
    );

    this.setState({ coregs: searchedCoregs });
  };

  handleCoreg(coreg, timeTaken) {
    API.getCoregSnapshots(coreg.id).then((res) => {
      const selectedCoreg = {
        ...coreg,
        snapshots: _filter(
          _orderBy(res, [(snapshot) => snapshot.date_taken], ['desc']), (res) => (
            moment(res.date_taken).add(1, 'day').format('MMM YYYY') === timeTaken
          )
        ),
        timeTaken,
      };

      // console.info('SelectedCoreg', selectedCoreg);

      this.setState({ showDetailModal: true, selectedCoreg });
    });
  }

  selectCoreg(coregIndex) {
    const splits = coregIndex.split('-');
    this.handleCoreg(this.state.coregs[splits[0]], splits[1]);
  }

  checkClosedStatus(selectedCoreg, datetime) {
    const { data } = selectedCoreg;
    const { closedListByDateTime } = data;

    if (!closedListByDateTime) return false;

    return closedListByDateTime.includes(datetime);
  }

  onClickPublicationRegistration() {
    this.props.assignAttribute('type', 6);
  }

  render() {
    const { coregs, searchText, selectedCoreg, loading } = this.state;

    return (
      <div className="dashboard">
        <Heading text="Hello! Let's Get Started." />

        <Row className="content">
          <Col md={12} sm={12} className="dash-buttons">
            <div className="services create">
              <Link to='/publication-reg/title-information' onClick={this.onClickPublicationRegistration.bind(this)}>
                <div className="service">
                  <div className="title">Setup Monthly Publication Registration</div>
                </div>
              </Link>
            </div>

            {/* <div className="services">
              <Link to={'/copyright-reg'}>
                <div className="service">
                  <div className="title">Register Individual Copyright</div>
                </div>
              </Link>
            </div> */}
          </Col>

          <Col md={12} sm={12}>
            <div className="agreement-page dashboard">
              <div className='agreement-filter-group'>
                <Select
                  className="form-control"
                  value=''
                  onChange={(e) => this.selectCoreg(e.target.value)}
                >
                  <option value="">Select publication</option>
                  {
                    coregs.length > 0 && coregs.map((coreg, idx) => (
                      coreg.uniqueDateTime.map((dateTaken) => (
                        (
                          <option key={`coreg_value_${idx}_${dateTaken}`} value={`${idx}-${dateTaken}`}>
                            {coreg.data.titleTypes.titleOfPublication} - {moment(dateTaken).format('MMM YYYY')}
                          </option>
                        )
                      ))
                    ))
                  }
                </Select>
                <SearchBar
                  searchText={searchText}
                  handleSearch={this.handleSearch}
                  clearSearch={this.clearSearch}
                />
              </div>

              {coregs.length > 0 ? (
                <div className="agreement-wrapper">
                  {
                    coregs.map((coreg, index) => (
                      coreg.uniqueDateTime.map(timeTaken => (
                        (
                          <div
                            key={`${index}-${timeTaken}`}
                            className="creg-view"
                            onClick={() => this.handleCoreg(coreg, timeTaken)}
                          >
                            <div className="title-view">
                              <div className="title">
                                <b>
                                  {coreg.data.titleTypes.titleOfPublication}
                                </b> -{' '}
                                <span>
                                  {moment(timeTaken).format('MMM YYYY')}
                                </span>
                              </div>
                              <br />
                            </div>
                            <div
                              className={`details text-right ${
                                this.checkClosedStatus(coreg, timeTaken) ? 'text-blue' : ''
                              }`}
                            >
                              <b>{this.checkClosedStatus(coreg, timeTaken) ? 'CLOSED' : 'PENDING'}</b>
                            </div>
                          </div>
                        )
                      ))
                    ))
                  }
                </div>
              ) : (
                <div className="text-center">
                  {searchText === '' && loading && (
                    <img src={loader} alt='Loading spinner' role='presentation' />
                  )}
                </div>
              )}
            </div>
          </Col>
        </Row>

        <Modal
          className="copyright-detail-modal"
          show={this.state.showDetailModal}
          onHide={() => this.setState({ showDetailModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedCoreg && selectedCoreg.data.titleTypes.titleOfPublication}
            </Modal.Title>
          </Modal.Header>
          {selectedCoreg && (
            <Modal.Body>
              <div className="creg-view">
                <div className='creg-view-url'>
                  <b>URL:</b> <a href={selectedCoreg.data.publishInfo.url}>
                    {selectedCoreg.data.publishInfo.url}
                  </a>  
                </div>
                <div>
                  <div
                    className={`details text-right ${
                      this.checkClosedStatus(selectedCoreg, selectedCoreg.timeTaken) && 'text-blue'
                    }`}
                  >
                    <b>{this.checkClosedStatus(selectedCoreg, selectedCoreg.timeTaken) ? 'CLOSED' : 'PENDING'}</b>
                  </div>
                  <div className={`details text-right`}>
                    {moment(selectedCoreg.date_created).format('MMM YYYY')}
                  </div>
                </div>
              </div>
              <div className='creg-image'>
                {
                  selectedCoreg.snapshots && selectedCoreg.snapshots.map((snapshot, idx) => (
                    <div key={`snapshot_${idx}`}>
                      <div className='flex justify-between items-center'>
                        <span><b>Updated:</b> {moment(snapshot.date_taken).add(1, 'day').format('MMM, YYYY')}</span>
                        <a href={snapshot.image.replace('png', 'pdf')} target='_blank'>
                          Download
                        </a>
                      </div>
                      <div>
                        <img src={snapshot.image} role='presentation' />
                      </div>
                      {
                        idx < selectedCoreg.snapshots.length - 1 && (
                          <hr />
                        )
                      }
                    </div>
                  ))
                }
              </div>
            </Modal.Body>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  subscription: state.payment.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});


export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// src/pages/Dashboard.jsx